import { PatientDetailPresenter } from '../../../../generic/patient-detail/patient-detail.presenter';
import { CollaboratorListKeys } from '../list/collaborator-list.key';
import { CollaboratorDetailKeys } from './collaborator-detail.key';
/**
 * O detalhe aberto pelo ADMIN, a partir da lista de Colaboradores.
 *
 * Uma das duas montagens do apresentador generico. Tudo o que a distingue da outra
 * esta no `mount`; o comportamento inteiro mora na base.
 *
 * `get mount()` e nao campo: acessor vive no PROTOTIPO e ja existe quando o
 * construtor da base roda. Campo de subclasse so nasce depois - e um factory
 * chamado no construtor da base resolveria isso, mas congelaria o valor errado para
 * sempre se algum dia lesse um campo da subclasse. O getter nao tem esse risco.
 */
export class CollaboratorDetailPresenter extends PatientDetailPresenter {
    get mount() {
        return MOUNT;
    }
}
const MOUNT = {
    section: 'collaborators',
    title: 'Colaboradores',
    subtitle: 'Lista de colaboradores cadastrados no sistema com dados e últimas medições',
    backLabel: 'Dados do Colaborador',
    keys: (app, intent) => new CollaboratorDetailKeys(app, intent),
    back: async (app) => {
        // Para a LISTAGEM, que hoje e irma e nao mais ancestral. O filtro vem
        // junto porque quem o guarda - o conceito - esta no caminho das duas.
        await CollaboratorListKeys.of(app).flip();
    }
};
//# sourceMappingURL=collaborator-detail.presenter.js.map